import React from 'react';

import {View, StyleSheet, FlatList} from 'react-native';

import TrustNotification from './TrustNotification';
import TrustPin from './TrustPin';

export const TrustPinWrapper = ({block, screenProps, fixedWidth}) => {
  const styles = fixedWidth ? railStyles : blockStyles;
  const notification = (
    <TrustNotification
      type={block.screenType}
      data={block.data}
      screenProps={screenProps}
    />
  );

  return (
    <View
      style={[styles.cardContainer, fixedWidth && {minWidth: 334, width: 334}]}>
      <TrustPin
        title={block.title}
        subtitle={block.subtitle}
        type={block.screenType}
        onPress={block.onPress}
        data={block.data}
        notification={notification}
      />
    </View>
  );
};

const TrustBlock = ({data: initialData, isRail, screenProps}) => {
  const styles = isRail ? railStyles : blockStyles;

  // filter out without an order
  const data = initialData.filter(d => d.order !== null);

  if (isRail) {
    return (
      <FlatList
        horizontal={true}
        contentContainerStyle={styles.container}
        data={data}
        renderItem={({item, index}) => (
          <TrustPinWrapper
            key={item.id || `block-${index}`}
            block={item}
            screenProps={screenProps}
            fixedWidth={isRail}
            isLast={index === data.length - 1}
          />
        )}
      />
    );
  }

  return (
    <View style={styles.container}>
      {data.map((block, index) => (
        <TrustPinWrapper
          key={block.id || `block-${index}`}
          block={block}
          screenProps={screenProps}
          isLast={index === data.length - 1}
        />
      ))}
    </View>
  );
};

const railStyles = StyleSheet.create({
  container: {
    padding: 12,
  },
  cardContainer: {
    paddingRight: 7,
    width: '100%',
    alignSelf: 'stretch',
  },
});

const blockStyles = StyleSheet.create({
  container: {
    paddingVertical: 6,
    paddingHorizontal: 12,
  },
  cardContainer: {
    paddingVertical: 6,
    width: '100%',
    alignSelf: 'stretch',
  },
});

export default TrustBlock;
